// extracted by mini-css-extract-plugin
export default {"custom-label":"LineChart_custom-label__8ktBe"};